import type { ReactNode } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import {
  AccountTreeRounded,
  CloseRounded,
} from '@mui/icons-material';


interface StacOrganizationMapDialogProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}


export default function StacOrganizationMapDialog({
  open,
  onClose,
  children,
}: StacOrganizationMapDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{
        sx: {
          bgcolor: '#020617',
          backgroundImage: 'none',
          color: '#f8fafc',
        },
      }}
    >
      <Box
        sx={{
          px: {
            xs: 1.5,
            md: 2.5,
          },
          py: 1.25,
          borderBottom:
            '1px solid rgba(148,163,184,0.14)',
          bgcolor: 'rgba(15,23,42,0.96)',
          flexShrink: 0,
        }}
      >
        <Stack
          direction="row"
          spacing={1.25}
          alignItems="center"
          justifyContent="space-between"
        >
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: 2.4,
                display: 'grid',
                placeItems: 'center',
                bgcolor: 'rgba(34,211,238,0.10)',
                border:
                  '1px solid rgba(34,211,238,0.18)',
                flexShrink: 0,
              }}
            >
              <AccountTreeRounded
                sx={{
                  color: '#22d3ee',
                }}
              />
            </Box>

            <Box
              sx={{
                minWidth: 0,
              }}
            >
              <Typography
                sx={{
                  color: '#f8fafc',
                  fontWeight: 950,
                  fontSize: '1rem',
                }}
              >
                Mapa organizativo
              </Typography>

              <Typography
                noWrap
                sx={{
                  color: '#64748b',
                  fontSize: '0.76rem',
                }}
              >
                Vista amplia para explorar y reorganizar la estructura STAC.
              </Typography>
            </Box>
          </Stack>

          <IconButton
            onClick={onClose}
            aria-label="Cerrar mapa organizativo"
            sx={{
              width: 40,
              height: 40,
              border:
                '1px solid rgba(148,163,184,0.16)',
              bgcolor: 'rgba(2,6,23,0.28)',
              flexShrink: 0,
            }}
          >
            <CloseRounded />
          </IconButton>
        </Stack>
      </Box>

      <DialogContent
        sx={{
          p: {
            xs: 1,
            md: 2,
          },
          overflow: 'auto',
          bgcolor: '#020617',
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}